export default "__VITE_ASSET__Dso1QRDU__"